module.exports = __webpack_public_path__ + "img/webb-logo.48131c6f.jpg";